import { useTranslation } from 'react-i18next';

const reviews = [
  {
    name: '新娱乐周刊',
    role: '合作媒体',
    text: '51吃瓜是目前行业内反应最快、信息最全的娱乐爆料平台，我们的编辑团队每天都把它作为重要信息源之一。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20media%20logo%20style%20avatar%2C%20editorial%20design%2C%20magazine%20aesthetic%2C%20warm%20tone%2C%20minimalist%20graphic&width=80&height=80&seq=review-avatar-01&orientation=squarish',
  },
  {
    name: '八卦观察室',
    role: '自媒体达人',
    text: '作为吃瓜博主，51吃瓜是我每天必刷的站点。很多独家线索都是从这里先看到的，时效性真的没得说。',
    avatar: 'https://readdy.ai/api/search-image?query=Blogger%20style%20avatar%2C%20creative%20personality%2C%20warm%20color%20palette%2C%20modern%20illustration%2C%20clean%20design%2C%20friendly%20expression&width=80&height=80&seq=review-avatar-02&orientation=squarish',
  },
  {
    name: '瓜田里的猹',
    role: '钻石瓜友',
    text: '从去年入坑到现在，每天早晚各刷一次51吃瓜已经成了习惯。信息更新快、内容靠谱，是我最信任的吃瓜平台。',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20animal%20themed%20avatar%2C%20hedgehog%20character%2C%20warm%20and%20friendly%2C%20simple%20illustration%20style%2C%20soft%20colors%2C%20minimalist&width=80&height=80&seq=review-avatar-03&orientation=squarish',
  },
  {
    name: '娱乐圈老司机',
    role: '认证瓜友',
    text: '在这个信息爆炸的时代，51吃瓜能帮我快速筛选出真正值得关注的爆料，省时又省力，好评！',
    avatar: 'https://readdy.ai/api/search-image?query=Veteran%20driver%20themed%20avatar%2C%20experienced%20expression%2C%20stylish%20illustration%2C%20warm%20brown%20tones%2C%20modern%20design&width=80&height=80&seq=review-avatar-04&orientation=squarish',
  },
  {
    name: '娱乐独角兽',
    role: '行业分析师',
    text: '从专业角度看，51吃瓜的信息核实机制在同类平台中属于上乘，不是那种为了流量乱发假料的野鸡平台。',
    avatar: 'https://readdy.ai/api/search-image?query=Analyst%20professional%20avatar%2C%20glasses%2C%20smart%20look%2C%20business%20casual%20style%2C%20warm%20neutral%20colors%2C%20clean%20illustration&width=80&height=80&seq=review-avatar-05&orientation=squarish',
  },
  {
    name: '今日份快乐来源',
    role: '资深瓜友',
    text: '每天上班摸鱼必备！刷新一下51吃瓜就能掌握全网最新动态，同事都以为我是八卦小灵通。',
    avatar: 'https://readdy.ai/api/search-image?query=Happy%20smiling%20character%20avatar%2C%20joyful%20expression%2C%20bright%20warm%20colors%2C%20simple%20illustration%2C%20modern%20minimalist%20design&width=80&height=80&seq=review-avatar-06&orientation=squarish',
  },
];

export default function AboutReviews() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-accent-50/50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs text-accent-700 font-medium tracking-wide uppercase">
              {t('about_reviews_label')}
            </span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            {t('about_reviews_title1')}
            <br />
            {t('about_reviews_title2')}
          </h2>
          <p className="text-sm text-foreground-600 mt-3">{t('about_reviews_subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((r, idx) => (
            <div
              key={idx}
              className={`bg-background-50 rounded-2xl p-5 transition-all duration-300 hover:scale-[1.02] ${
                idx === reviews.length - 1 ? 'opacity-60' : ''
              }`}
            >
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span key={star} className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-sm"></i>
                  </span>
                ))}
              </div>
              <p className="text-sm font-medium text-foreground-900 mb-4">{r.text}</p>
              <div className="flex items-center gap-3">
                <img
                  src={r.avatar}
                  alt={r.name}
                  className="w-9 h-9 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-medium text-foreground-950">{r.name}</p>
                  <p className="text-xs text-foreground-500">{r.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}